import { Autocomplete, Box, Fade, TextField, Typography } from "@mui/material";
import dayjs from "dayjs";
import "dayjs/locale/es";

export const InfoGeneral = ({ equipo, setEquipo, acolitos }) => {
  return (
    <Fade in={true} timeout={1000}>
      <Box sx={style.modal}>
        <Typography
          id="transition-modal-title"
          variant="h4"
          sx={style.modal_title}
          color="primary"
          fontWeight={900}
        >
          EDITAR EQUIPO
        </Typography>
        <Box
          sx={{
            width: "80%",
            margin: "auto",
            marginBottom: 2,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography
            variant="body1"
            color="secondary.dark"
            // fontWeight={500}
          >
            Equipo creado el día{" "}
            {dayjs(equipo.fecha_comienzo)
              .locale("es")
              .format("D [de] MMMM [de] YYYY")}
          </Typography>
          <Typography
            variant="body1"
            color="secondary.dark"
            // fontWeight={500}
          >
            {equipo.num_acolitos} integrantes
          </Typography>
        </Box>
        <Box
          sx={{
            padding: 5,
            borderRadius: 7,
            //Agregar sombra
            boxShadow: 5,
            width: "80%",
            margin: "auto",
            position: "relative",
          }}
        >
          {/* Mostrar en la parte superior derecha el estado del equipo */}
          <Box
            sx={{
              position: "absolute",
              top: 20,
              right: 20,
              backgroundColor: "success.main",
              padding: 1,
              borderRadius: 2,
            }}
          >
            <Typography variant="body" color="white" fontWeight={"bold"}>
              Activo
            </Typography>
          </Box>

          <Typography
            id="transition-modal-description"
            variant="h6"
            color="secondary.dark"
            fontWeight={500}
            sx={{ marginBottom: 4 }}
          >
            Información general
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                width: "50%",
              }}
            >
              <Typography
                variant="h6"
                color="primary"
                sx={{
                  marginRight: 2,
                }}
              >
                Nombre del equipo:
              </Typography>
              <TextField
                variant="outlined"
                value={equipo.nombre}
                onChange={(e) =>
                  setEquipo({ ...equipo, nombre: e.target.value })
                }
                sx={{ width: "55%" }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                width: "50%",
              }}
            >
              <Typography variant="h6" color="primary" sx={{ marginRight: 2 }}>
                Capitán:
              </Typography>
              <Autocomplete
                disablePortal
                options={acolitos}
                value={
                  acolitos.find(
                    (acolito) => acolito.id === equipo.id_capitan
                  ) || null
                }
                fullWidth
                renderInput={(params) => (
                  <TextField {...params} label="Nombre del acólito" />
                )}
                getOptionLabel={(option) => option.nombre_completo}
                isOptionEqualToValue={(option, value) => option === value}
                onChange={(event, value) => {
                  value
                    ? setEquipo({
                        ...equipo,
                        id_capitan: value.id,
                        capitan: value.nombre_completo,
                      })
                    : setEquipo({ ...equipo, id_capitan: null, capitan: "" });
                }}
                noOptionsText="Sin resultados"
                sx={{ width: "70%", marginRight: 2 }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Fade>
  );
};

const style = {
  modal: {
    // position: "absolute",
    top: "50%",
    left: "50%",
    // transform: "translate(-50%, -50%)",
    // width: "65%",
    bgcolor: "background.paper",
    // boxShadow: 24,
    p: 4,
    // borderRadius: 2,
  },
  modal_title: {
    textAlign: "center",
    marginBottom: 5,
  },
  inputs: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 5,
    justifyContent: "space-around",
  },
};
